(function () {
    'use strict';

    var button = document.querySelector('.trailers-filter-btn');
    if (!button) {
        return;
    }

    var modal = false;
    button.addEventListener('click', function () {
        // Create modal element
        modal = document.createElement('div');
        modal.className = 'fixed inset-0 bg-primary z-50 modal trailers-filter-modal';
        modal.setAttribute('tabindex', '-1');
        modal.setAttribute('role', 'dialog');

        // Create modal structure
        var modalDialog = document.createElement('div');
        modalDialog.className = 'modal-dialog';
        modalDialog.setAttribute('role', 'document');

        var modalContent = document.createElement('div');
        modalContent.className = 'modal-content';

        var iframe = document.createElement('iframe');
        iframe.src = '/_Resources/Static/Packages/CodeQ.Site/TrailerFilterConsultation/dist/index.html';
        iframe.setAttribute('frameborder', '0');
        iframe.onload = function () {
            self.scrollTo(0, 0);
        };
        iframe.style.cssText = 'width: 100%; overflow: hidden; height: 700px; max-height: 90vh;';
        iframe.setAttribute('scrolling', 'no');

        // Assemble modal
        modalContent.appendChild(iframe);
        modalDialog.appendChild(modalContent);
        modal.appendChild(modalDialog);

        // Add to body and show
        document.body.appendChild(modal);
        showModal(modal);
    });

    function showModal(modalElement) {
        // Add Bootstrap modal classes and show
        modalElement.classList.add('show');
        modalElement.style.display = 'block';
        modalElement.style.opacity = '1';
        document.body.classList.add('modal-open');

        // Add backdrop
        var backdrop = document.createElement('div');
        backdrop.className = 'modal-backdrop fade show';
        document.body.appendChild(backdrop);
        modalElement.backdrop = backdrop;

        // Close on backdrop click
        backdrop.addEventListener('click', closeModal);

        // Close on escape key
        var escapeHandler = function (e) {
            if (e.key === 'Escape') {
                closeModal();
            }
        };
        document.addEventListener('keydown', escapeHandler);
        modalElement.escapeHandler = escapeHandler;
    }

    function closeModal() {
        if (!modal) {
            return;
        }

        modal.style.opacity = '0';
        setTimeout(function () {
            hideModal(modal);
        }, 300);
    }

    function hideModal(modalElement) {
        // Remove modal
        modalElement.classList.remove('show');
        modalElement.style.display = 'none';
        document.body.classList.remove('modal-open');

        // Remove backdrop
        if (modalElement.backdrop) {
            modalElement.backdrop.remove();
        }

        // Remove escape handler
        if (modalElement.escapeHandler) {
            document.removeEventListener('keydown', modalElement.escapeHandler);
        }

        // Remove modal from DOM
        modalElement.remove();
        modal = false;
    }

    function filterBooqableEntriesOnBooqableProductPropertiesReady(config) {
        // booqableProductProperties loading is a deferred script
        if (window.booqableProductProperties) {
            filterBooqableEntries(config);
        } else {
            setTimeout(function () {
                filterBooqableEntriesOnBooqableProductPropertiesReady(config);
            }, 300);
        }
    }

    function filterBooqableEntries(config) {
        // set the config to the url
        var title = document.querySelector('title').innerText;
        var url =
            location.href.indexOf('?') === -1 ? location.href : location.href.substr(0, location.href.indexOf('?'));
        if (window.history && typeof window.history.replaceState === 'function') {
            var urlWithParameters =
                url +
                '?license=' +
                config.license +
                '&maxCarWeight=' +
                config.maxCarWeight +
                '&maxTrailerWeight=' +
                config.maxTrailerWeight +
                '&maximalAllowedWeight=' +
                config.maximalAllowedWeight;
            window.history.replaceState('', title, urlWithParameters);
        }

        // adopt the filter box content
        var paragraph = document.querySelector('.trailers-filter-paragraph');
        if (paragraph) {
            paragraph.remove();
        }
        var headline = document.querySelector('.trailers-filter-headline');
        if (config.license === 'licenseB' || config.license === 'licenseBCode96') {
            headline.innerHTML =
                'Mit der <strong>Führerscheinklasse ' +
                licenseName(config.license) +
                '</strong> und Ihrem Fahrzeug können Sie Anhänger bis zu einem Gewicht von <strong>' +
                config.maximalAllowedWeight +
                ' kg</strong> ziehen.';
        } else {
            headline.innerHTML =
                'Mit der <strong>Führerscheinklasse ' +
                licenseName(config.license) +
                '</strong> können Sie <strong>alle Anhänger</strong> führen.';
        }
        button.innerHTML = 'Filter anpassen';

        // first show all products
        var booqableProducts = document.querySelectorAll('.booqable-product');
        booqableProducts.forEach(function (product) {
            product.style.display = '';
        });

        var neosProductLists = document.querySelectorAll('.neos-booqable-product-list');
        neosProductLists.forEach(function (list) {
            list.style.display = '';
        });

        // now filter known products
        window.booqableProductProperties.forEach(function (product) {
            if (!product.trailerWeight || product.trailerWeight > config.maximalAllowedWeight) {
                var productElement = document.querySelector('.booqable-product[data-id="' + product.id + '"]');
                if (productElement) {
                    productElement.style.display = 'none';
                }
            }
        });

        var productLists = document.querySelectorAll('.booqable-product-list');
        productLists.forEach(function (list) {
            if (list.offsetHeight === 0) {
                // if there no content, hide the whole group
                var parent = list.parentElement;
                if (parent && parent.classList.contains('neos-booqable-product-list')) {
                    parent.style.display = 'none';
                }
            }
        });
    }

    function licenseName(license) {
        const translations = {
            licenseB: 'B',
            licenseBCode96: 'B Code 96',
            licenseEtoB: 'E zu B',
            licenseBE: 'BE',
        };
        return translations[license] || 'unbekannt';
    }

    function getUrlParameter(name) {
        name = name.replace(/\[/, '\\[').replace(/\]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    if (getUrlParameter('license')) {
        window.trailerFilterCurrentConfig = {
            license: getUrlParameter('license'),
            maxCarWeight: parseInt(getUrlParameter('maxCarWeight'), 10),
            maxTrailerWeight: parseInt(getUrlParameter('maxTrailerWeight'), 10),
            maximalAllowedWeight: parseInt(getUrlParameter('maximalAllowedWeight'), 10),
        };

        filterBooqableEntriesOnBooqableProductPropertiesReady(window.trailerFilterCurrentConfig);
    }

    window.document.addEventListener('trailers-filter-close', function handleEvent() {
        closeModal();
    });

    window.trailerFilterCurrentConfig = window.trailerFilterCurrentConfig || false;
    window.document.addEventListener(
        'trailers-filter-by',
        function handleEvent(e) {
            closeModal();
            window.trailerFilterCurrentConfig = e.detail;
            filterBooqableEntriesOnBooqableProductPropertiesReady(e.detail);

            // booqableProductProperties loading is a deferred script
            setTimeout(function () {
                if (!window.booqableProductProperties) {
                    alert('Leider können die Anhänger derzeit nicht gefiltert werden.');
                }
            }, 2000);

            // scroll to the filtered products
            var filterBlock = document.querySelector('.trailers-filter-block');
            if (filterBlock) {
                filterBlock.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        },
        false
    );
})();
